import { cn } from './ui';

/**
 * The Aura lockup — the halftone mark and the wordmark together.
 *
 * Both cuts are rendered and one is hidden by CSS (`.brand-light` /
 * `.brand-dark` in `index.css`). `display: none` takes the hidden one out of
 * the accessibility tree too, so exactly one `alt` is ever announced.
 */
export function Logo({ className }: { className?: string }) {
  const size = cn('w-auto', className ?? 'h-6');
  return (
    <>
      <img src="/logo.png" alt="Aura" className={cn('brand-light', size)} />
      <img src="/logo-dark.png" alt="Aura" className={cn('brand-dark', size)} />
    </>
  );
}
